import Box from '@totallymoney/ui/components/Box'

import {
    ModalType,
    ScoredCreditCardProduct,
} from '@appTypes/EligibilityApi.interface'

import useSetState from '@hooks/useSetState'

import CardDetailsTable from './components/RatesAndFeesCard'
import RatesAndFeesModal from './components/RatesAndFeesModal'
import { createRatesAndFeesCardContent } from './utils/createRatesAndFeesCardContent'

interface RatesAndFeesProps {
    card: ScoredCreditCardProduct
}

type ModalState = {
    activeModal: ModalType | null
}

const defaultModalState = {
    activeModal: null,
}

const RatesAndFees = ({ card }: RatesAndFeesProps) => {
    const [modalState, updateModalState] =
        useSetState<ModalState>(defaultModalState)

    const [
        annualInterestRatesContent,
        balanceTransferContent,
        purchaseOfferContent,
        otherKeyFactsContent,
    ] = createRatesAndFeesCardContent(card)

    const handleModalClose = () => updateModalState(defaultModalState)

    return (
        <Box
            display="grid"
            gridTemplateColumns={['1fr', 'repeat(2, 1fr)', 'repeat(4, 1fr)']}
            gridGap="space20"
        >
            <CardDetailsTable
                heading="Balance transfer offer"
                content={balanceTransferContent}
                onClick={() =>
                    updateModalState({
                        activeModal: ModalType.BalanceTransferOfferModal,
                    })
                }
            />

            <CardDetailsTable
                heading="Purchase offer"
                content={purchaseOfferContent}
                onClick={() =>
                    updateModalState({
                        activeModal: ModalType.PurchaseOfferModal,
                    })
                }
            />

            <CardDetailsTable
                heading="Annual interest rates"
                content={annualInterestRatesContent}
                onClick={() =>
                    updateModalState({
                        activeModal: ModalType.AnnualInterestRatesModal,
                    })
                }
            />

            <CardDetailsTable
                heading="Other key facts"
                content={otherKeyFactsContent}
                onClick={() =>
                    updateModalState({
                        activeModal: ModalType.OtherKeyFactsModal,
                    })
                }
            />

            <RatesAndFeesModal
                modalType={modalState.activeModal}
                onModalClose={handleModalClose}
            />
        </Box>
    )
}

export default RatesAndFees
